import React, { useEffect, useContext, useState } from 'react'
import { MsalContext } from '@azure/msal-react'
import { useParams } from 'react-router-dom';
import { callApiWithAuthorization } from '../../API/CallApi';
import { SimpleConfigProvider } from '../../Context/Portal/SimpleConfigContext';
import SimpleConfig from './SimpleConfig/SimpleConfig';
import { getLoggedInUserUsingAccessToken } from '../../API/User/User';
import { useTranslation } from 'react-i18next';
import { getProject } from '../../API/Project/project';

export default function RuntimePortalConfigPage() {

    const params = useParams();
    const { organisationId, projectId, instanceId, portalId } = params;

    const context = useContext(MsalContext);
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const [accessError, setAccessError] = useState("");
    const [user, setUser] = useState({});
    const [organization, setOrganization] = useState({});
    const [subscription, setSubscription] = useState({});
    const [project, setProject] = useState({});

    const { i18n, ready: tReady } = useTranslation();

    useEffect(() => {
        getUserUsingAccessToken();
    }, []);

    useEffect(() => {
        if (user && user.oid) {
            validateAccessToProject()
        }
    }, [user])

    useEffect(() => {
        if (tReady) {
            // i18n.changeLanguage(organization.platformLanguage || "en");
        }
    }, [tReady, organization])

    async function getUserUsingAccessToken() {
        const user = await getLoggedInUserUsingAccessToken();
        setUser(user);
    }

    const validateAccessToProject = async () => {
        setLoading(true)
        const [hasAccessToOrganisation, hasAccessToProject] = await Promise.all([
            checkAccessToOrganisation(),
            checkAccessToProject()
        ])
        if (hasAccessToOrganisation === false) {
            setHasAccess(false);
            setAccessError("Sorry. You have not been granted access to this Organization. Please contact the Admin(s).");
            setLoading(false);
            return;
        }
        if (hasAccessToProject.access === false) {
            setHasAccess(false);
            setAccessError(hasAccessToProject.error);
            setLoading(false);
            return;
        }
        setHasAccess(true)
        setAccessError("")
        setLoading(false);
    }

    const checkAccessToOrganisation = async () => {
        const roleOfUserInOrganisationsRequest = await callApiWithAuthorization("/api/v0/getOrganizationUserRole/" + user.emails[0]);
        const roleOfUserInOrganisations = await roleOfUserInOrganisationsRequest.json();
        const currentOrganization = roleOfUserInOrganisations.find(organisation => organisation._id === organisationId);
        const { subscription } = currentOrganization;
        setSubscription(subscription);
        const doesUserHaveRoleInCurrentOrganisation = roleOfUserInOrganisations.findIndex(organisation => organisation._id === organisationId) > -1
        return doesUserHaveRoleInCurrentOrganisation;
    }

    const checkAccessToProject = async () => {
        const project = await getProject(projectId);
        if (project.length === 0) {
            return {
                access: false,
                error: "Sorry, the application you are trying to access is deleted."
            };
        }
        if (project.isActive === false) {
            return {
                access: false,
                error: "Sorry, the application you are trying to access is not active."
            };
        }
        setProject(project);
        return {
            access: true,
            error: ""
        }
    }

    if (loading === true) {
        return (
            <>
                <div className='d-flex flex-column h-100'>
                    <div className='row' style={{ marginTop: 10 }}>
                        <div className='col-10'><div className='sk'></div></div>
                        <div className='col-2'><div className='sk'></div></div>
                    </div>
                    <div className='flex-grow-1 sk' style={{ marginTop: 25 }}>
                    </div>
                </div>
            </>
        )
    }

    if (hasAccess === false) {
        return (
            <div class="d-flex justify-content-center m-4">
                <div className="text-center">
                    <img
                        width={200}
                        alt="Progress-Loader"
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/Error.png`}
                    />
                    <div className="font-size-2 mx-5 px-5">
                        {accessError}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="h-100">
            <SimpleConfigProvider>
                <SimpleConfig
                    accessedFromRuntime={true}
                    msalContext={context}
                    publisherId={user.oid}
                    organisationId={organisationId}
                    subscription={subscription}
                    projectId={projectId}
                    project={project}
                    portalId={portalId}
                    instanceId={instanceId}
                />
            </SimpleConfigProvider>
        </div>
    );
}
